import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { supabase } from '../utils/supabaseClient.js';
import SEO from './SEO.js';
import ProductBox from './ProductBox.js';
import ProductSkeleton from './ProductSkeleton.js';

const TagPage = () => {
  const { tagName } = useParams();
  const [products, setProducts] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  
  const PER_PAGE = 12;

  const loadProducts = useCallback(async () => {
    try {
      const from = page * PER_PAGE;
      const to = from + PER_PAGE - 1;

      // Filter by Keywords array
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .contains('keywords', [tagName]) 
        .range(from, to);

      if (error) throw error;

      if (data.length === 0) setHasMore(false);
      
      const mapped = data.map(p => ({
        ...p, name: p.title, imageUrls: p.image_urls || [], keywords: p.keywords || []
      }));

      setProducts(prev => [...prev, ...mapped]);

    } catch (err) {
      console.error(err);
    }
  }, [page, tagName]);

  useEffect(() => {
    setProducts([]);
    setPage(0);
    setHasMore(true);
    loadProducts();
  }, [tagName]);

  useEffect(() => {
    if (page > 0) loadProducts();
  }, [page, loadProducts]);

  return (
    <div className="container mt-5">
      <SEO title={`#${tagName} Products`} />
      <h1 className="mb-4">Tag: #{tagName}</h1>
      
      <InfiniteScroll
        dataLength={products.length}
        next={() => setPage(p => p + 1)}
        hasMore={hasMore}
        loader={<div className="row">{[...Array(4)].map((_, i) => <ProductSkeleton key={i} />)}</div>}
      >
        <div className="row">
          {products.map(p => <ProductBox key={p.id} product={p} />)}
        </div>
      </InfiniteScroll>
      
      {products.length === 0 && <p className="mt-5 text-center">No products found with this tag.</p>}
    </div>
  );
};

export default TagPage;